import styled from 'styled-components';

export const EditProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SendProjectHeader = styled.header`
  margin-bottom: 1.5rem;
  & > span {
    color: ${({ theme }) => theme.colors.grayDark3};
    font-size: 1rem;
  }
`;
